import { build_table_cell } from "./formal_document_template_helpers";

const normalize_question_id = (value) => String(value || "");

const get_binding_question_id = (row) =>
  normalize_question_id(row?.binding?.section_question_id);

const is_managed_question_row = (row) =>
  row?.binding?.source_type === "section_question" && Boolean(get_binding_question_id(row));

const has_meaningful_manual_content = (row) => {
  const source_type = row?.binding?.source_type || "";
  const label = String(row?.label || "").trim();
  const static_value = String(row?.binding?.value || "").trim();
  if (source_type === "system_field") {
    return Boolean(label) || row?.binding?.system_field !== "entity_name";
  }
  if (source_type === "static_text") {
    return Boolean(label || static_value);
  }
  return Boolean(label);
};

const map_managed_rows = (rows) =>
  (rows || []).reduce((accumulator, row) => {
    const question_id = get_binding_question_id(row);
    if (is_managed_question_row(row)) {
      Reflect.set(accumulator, question_id, row);
    }
    return accumulator;
  }, {});

const build_ordered_question_rows = (selected_ids, existing_rows, build_row) => {
  const managed_rows = map_managed_rows(existing_rows);
  return (selected_ids || []).map((question_id) => {
    const normalized_id = normalize_question_id(question_id);
    const row_data = Reflect.get(managed_rows, normalized_id) || null;
    return build_row(normalized_id, row_data);
  });
};

export const get_bound_question_ids = (rows) =>
  (rows || [])
    .filter(is_managed_question_row)
    .map((row) => get_binding_question_id(row));

export const sync_question_bound_rows = (existing_rows, selected_ids, build_row) => {
  const preserved_rows = (existing_rows || []).filter(
    (row) => !is_managed_question_row(row) && has_meaningful_manual_content(row)
  );
  const ordered_rows = build_ordered_question_rows(selected_ids, existing_rows, build_row);
  return [...preserved_rows, ...ordered_rows];
};

export const sync_question_bound_columns = (existing_columns, selected_ids, build_column) => {
  const preserved_columns = (existing_columns || []).filter(
    (column) => !is_managed_question_row(column) && has_meaningful_manual_content(column)
  );
  const ordered_columns = build_ordered_question_rows(
    selected_ids,
    existing_columns,
    build_column
  );
  return [...preserved_columns, ...ordered_columns];
};

export const rebuild_static_rows_for_columns = (rows, previous_columns, next_columns) =>
  (rows || []).map((row) => {
    const cell_map = new Map(
      (previous_columns || []).map((column, index) => [
        column.local_id,
        Reflect.get(row, index)
      ])
    );
    return (next_columns || []).map((column) => {
      const existing_cell = cell_map.get(column.local_id);
      return existing_cell || build_table_cell();
    });
  });
